export const EXPORT_FILE_NAME = `Contract Sweep Recipient Tab`;

export const TAB_TRANSLTE_PREFIX = "contractSweepRecipientTab";
